import Task from './Task';

function Tasks({ tasks, onDelete, onToggle }) {

    return (
        <>
            {tasks.map(task => {
                return (
                    <Task key={task.id} {...task} onDelete={onDelete} onToggle={onToggle} />
                )
            })}
        </>
    )
}

export default Tasks